const lazySizes = require('lazysizes/lazysizes');
lazySizes.cfg.loadMode = 1; // only load visible elements
module.exports = lazySizes;
